import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutline } from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function PlanRequestApprovedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const { plan } = notification.data;

  return (
    <NotificationRowContent
      notification={notification}
      icon={CheckCircleOutline}
      title={t('planRequest.approvedNotification.title', { ns: 'notifications' })}
      body={t('planRequest.approvedNotification.body', { name: plan?.name, ns: 'notifications' })}
    />
  );
}

PlanRequestApprovedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      plan: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default PlanRequestApprovedNotification;
